// src/features/landing/infrastructure/jobApplyApiRepository.js

const API_BASE_URL = process.env.REACT_APP_RECRUIT_API_URL || 'http://localhost:8080';

/**
 * @param {Object} applyData
 * @param {number} applyData.jobPostId
 * @param {string} applyData.applicantName
 * @param {string} applyData.applicantContact
 * @param {string} [applyData.applicantEmail]
 * @param {string} [applyData.applicantZipcode]
 * @param {string} [applyData.applicantRoadAddress]
 * @param {string} [applyData.applicantJibunAddress]
 * @param {string} [applyData.applicantDetailAddress]
 * @param {string} [applyData.applicantSido]
 * @param {string} [applyData.applicantSigungu]
 * @param {string} [accessToken] 로그인 상태면 전달 — 백엔드가 job_apply.member_id에 회원 ID를 기록. 없어도 지원은 정상 처리됨(비로그인 지원 허용).
 * @returns {Promise<Object>}
 */
async function createJobApply(applyData, accessToken) {
    const headers = { 'Content-Type': 'application/json' };
    if (accessToken) headers['Authorization'] = `Bearer ${accessToken}`;
    const response = await fetch(
        `${API_BASE_URL}/api/job-applies`,
        {
            method: 'POST',
            headers,
            body: JSON.stringify(applyData),
        }
    );

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || '지원 신청에 실패했습니다.');
    }

    return response.json();
}

export const jobApplyRepository = {
    createJobApply,
};
